export default "__VITE_ASSET__Bhivp0Er__"